import type { PreviewTarget } from '@/features/proactive-agents/proactive-agents-types';
import { useStoredValue } from '@/features/proactive-agents/useStoredValue';

// The last change this admin started, kept across reloads and shared by the page's tabs so they can show how far it
// has come. `target` is the agent and users it was made for, and `started_at` when it was confirmed, in ms.
export type LastUserChange = {
  change_id: string;
  name: string;
  target: PreviewTarget | null;
  started_at: number;
};

const parseLastChange = (stored: unknown): LastUserChange | null => {
  const change = stored as Partial<LastUserChange> | null;
  return typeof change?.change_id === 'string' &&
    typeof change.name === 'string' &&
    typeof change.target === 'object' &&
    typeof change.started_at === 'number'
    ? {
        change_id: change.change_id,
        name: change.name,
        target: change.target,
        started_at: change.started_at,
      }
    : null;
};

export const useLastUserChange = (adminEmail: string) =>
  useStoredValue(
    `proactive-agents.last-user-change:${adminEmail}`,
    parseLastChange
  );
